module.exports = __webpack_public_path__ + "img/timelapse.34da434.jpg";